import React from "react";
import {
  Container,
  InnerContainer,
  Card,
  ImageContainer,
  LinkRow,
} from "./Sponsor.styled";
import { getStaticImg } from "../../../utils/function";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

// Figma System Icon/sa-arrow-right (#1F2D3D) — inline to avoid an asset fetch.
const ArrowRight = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#1F2D3D"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className="shrink-0"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

const Sponsor = ({ title, contents, titleClassName = "" }) => {
  const handleClick = (val) => {
    if (val?.content_url) return window.open(val.content_url, "_blank");
    return false;
  };

  return (
    <Container>
      <img
        id="title-img"
        className={`mx-auto z-20 lg:max-w-[428px] lg:h-[55px] md:mt-0 md:mb-0 ${
          contents?.length >= 8 ? "mt-[12svh]" : "mt-0"
        }`}
        style={{
          objectFit: "contain",
          objectPosition: "center",
        }}
        src={getStaticImg("illustration/sponsored-by.png")}
        alt={title || "sponsored by"}
      />
      <InnerContainer>
        {contents?.map((value, idx) => (
          <Card key={idx} onClick={() => handleClick(value)}>
            <ImageContainer>
              <img
                src={imgPath + value?.key_visual}
                alt={value?.title || "sponsor"}
                className="max-h-[112px] max-w-full w-auto h-auto object-contain z-20"
              />
            </ImageContainer>
            <LinkRow>
              Kunjungi Halaman Situs
              <ArrowRight />
            </LinkRow>
          </Card>
        ))}
      </InnerContainer>
    </Container>
  );
};

export default Sponsor;
